import React, { useEffect, useState } from "react";
import { useParams, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../loader/Loader";
import { useDispatch } from "react-redux";
import { set_audit_modes, set_audit_status as setAuditStatusRedux } from "../store/images";
import ExpiredStatus from "./ExpiredStatus";
import SuccessComponent from "../audit-completion-module/SuccessComponent";
import moment from "moment";

const ModePrRoute = ({children}) => {
  const [user_modes, set_user_modes] = useState([]);
  const [redirect_url, set_redirect_url] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { audit_id } = useParams();
  const [isValid, setIsValid] = useState(null);
  const [loading, setLoading] = useState(true);
  const [audit_status, setAuditStatus] = useState(null); // Renamed to avoid conflict

  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100svh",
      backgroundColor: "#ffffff",
    },
    image: {
      maxWidth: "90vw",
      maxHeight: "90vh",
      width: "auto",
      height: "auto",
      animation: "fadeInOut 4s ease-in-out infinite, pulse 2s ease-in-out infinite",
    },
  };

  const not_found = `${process.env.PUBLIC_URL}/inspection-images/not_found.png`;

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(`/create_audit/get_audit_details2/${audit_id}`);
        console.log("200", response.data);

        const config = response.data?.inspection_config;
        if (config?.selectedMode?.length > 0) {
          const lowercaseModes = config.selectedMode.map(mode => mode.toLowerCase());
          console.log("50", lowercaseModes);

          dispatch(set_audit_modes(lowercaseModes));
        }
      } catch (error) {
        console.error("Error fetching audit details:", error);
      }
    };

    if (audit_id) {
      fetchDetails();
    }
  }, [audit_id]);


  useEffect(() => {
    const checkTokenValidity = async () => {
      try {
        const res = await axios.post("/create_audit/verify_token_claim", { audit: audit_id, processed: 0, inspection_time: moment().format("DD-MM-YYYY HH:mm") });
        console.log("45 status", res);
        dispatch(setAuditStatusRedux(res.data)); // Redux action
        setAuditStatus(res.data); // Local state
        setIsValid(true);
        const res2 = await axios.post('/create_audit/get_modes2', {
          audit: audit_id,
        });
        // dispatch(set_audit_modes(res2.data))
        set_user_modes(res2.data);
        const hostname = window.location.hostname;
        const port = window.location.port;
        let baseURL = port !== '' ? `https://${hostname}:${port}` : `https://${hostname}`;

        if (res2.data.length === 1) {
          const url = `${baseURL}/audit/${res2.data[0]}/permission/${audit_id}`;
          set_redirect_url(url);
          // navigate(url);
        }
      } catch (err) {
        console.error("Error", err.response?.data || err.message);
        setIsValid(false);
      } finally {
        setLoading(false);
      }
    };

    checkTokenValidity();
  }, [audit_id, dispatch]);


  if (loading) {
    return <Loader />;
  }
  if (redirect_url) {
    // Use window.location.href to navigate, causing a full page reload
    window.location.href = redirect_url;
    return null; // Return null or an empty fragment to prevent rendering
  }

  if (audit_status === "Expired !") {
    return <ExpiredStatus />;
  }

  if (audit_status === "Audit not Found !") {
    return <div style={styles.container}> <img src={not_found} alt="not_found" style={styles.image} /></div>;
  }

  if (audit_status === "Success !") {
    return children;
  }

  if (audit_status === "Already Completed !") {
    return <SuccessComponent />;
  }


  return isValid ? children : <Navigate to="/no-access" />;

};

export default ModePrRoute;

